import { render } from "./NewAcceptTermForm.vue?vue&type=template&id=210f01a3&scoped=true"
import script from "./NewAcceptTermForm.vue?vue&type=script&lang=js"
export * from "./NewAcceptTermForm.vue?vue&type=script&lang=js"

import "./NewAcceptTermForm.vue?vue&type=style&index=0&id=210f01a3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210f01a3"]])

export default __exports__